import watchAppInit from './getTokensSaga';

export default [
  watchAppInit(),
];
